import { useNavigate } from "react-router-dom";

function LowInventoryItem({ item }) {
    const navigate = useNavigate();

    function handleEditStocks() {
        navigate('/inventory-management');
    }

    return (
        <div className="flex items-center border-t border-[#EAEAEA] font-medium">
            <div className="w-[55%] max-[1280px]:w-[47.5%] max-[1080px]:w-[43%] px-[10px] py-[6px] flex gap-[11px] items-center">
                <div className="size-16 rounded-lg overflow-hidden">
                    <img className='size-full object-cover' src={item.images[0]} alt="" />
                </div>

                <div className="flex flex-col gap-1 w-[calc(100%-64px-11px)]">
                    <h2 className="font-semibold text-[14px] leading-6 text-[#121212] whitespace-nowrap overflow-hidden text-ellipsis">{item.name}</h2>
                
                    <p className="flex gap-1 items-center text-[#666666] font-medium">
                        <span className='text-[12px] leading-6'>Size: {item.size}</span>
                        <span className='text-[12px] leading-6'>Color: {item.color[0].toUpperCase() + item.color.slice(1, item.color.length)}</span>
                    </p>
                </div>
            </div>

            <h2 className="w-[15%] max-[1280px]:w-[17.5%] max-[1080px]:w-[19%] px-[10px] py-[26px] text-[14px] leading-6 text-[#121212]">{item.SKU}</h2>
            
            <h2 className="w-[15%] max-[1280px]:w-[17.5%] max-[1080px]:w-[19%] px-[10px] py-[26px] text-[14px] leading-6 text-[#121212]">{item.stock}</h2>

            <div className="w-[15%] max-[1280px]:w-[17.5%] max-[1080px]:w-[19%] px-[10px] py-5">
                <button onClick={handleEditStocks} className='outline-none font-semibold text-[12px] leading-6 text-[#121212] w-full px-3 py-[6px] border border-[#757575] bg-[#F0F0F0] rounded-[4px]'>
                    Edit Stocks
                </button>
            </div>
        </div>
    );
}

export default LowInventoryItem;
